import React from 'react';

const ShippingMethodFormContext = React.createContext();

export default ShippingMethodFormContext;
